import styled from "styled-components";
import { theme } from "@themes";

const backgroundColor = {
  "blue-card": theme.primary.blueLight,
  "blue-card-3": theme.primary.blueLight,
  "yellow-card": theme.status.warningPale,
  "red-card": theme.status.errorPale,
};

const fontColor = {
  "blue-card": theme.primary.blueDark,
  "blue-card-3": theme.primary.blueDark,
  "yellow-card": theme.status.warningDark,
  "red-card": theme.status.warningDark,
};

const borderColor = {
  "blue-card": theme.primary.blue,
  "blue-card-3": theme.primary.blue,
  "yellow-card": theme.status.warning,
  "red-card": theme.status.error,
};

export const NotificationContent = styled.div`
  cursor: pointer;
  transition: all ease 0.3s;
  &:hover {
    background-color: ${({ theme }) => theme.neutral.gray[200]};
  }
`;

export const UserNoticeContainer = styled.div`
  width: 100%;
  height: fit-content;
  color: ${({ classIdentity }) => fontColor[classIdentity]};
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  padding: 10px 36px;
`;

export const HeaderContainer = styled.p`
  font-size: 16px;
  font-weight: 800;
  color: ${({ theme }) => theme.secondaryDarkOne};
  margin-bottom: 8px;
`;

export const ContentContainer = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.secondaryDarkOne};
  p {
    margin-bottom: 0px;
    text-align: justify;
  }
`;
